/** Return either 'value' if it's in [min,max] interval or closest boundary */
export const clamp = (value: number, min = 0, max = 1): number => {
    return Math.max(min, Math.min(value, max));
};
